import * as React from 'react';
import { Button } from '@cian/ui-kit';

import * as style from './SearchModalCancelButton.css';

export interface ISearchModalCancelButtonProps {
  onClick: () => void;
  size: 'XS' | 'M';
}

export const SearchModalCancelButton: React.FC<ISearchModalCancelButtonProps> = props => {
  const { onClick, size } = props;

  return (
    <div className={style['container']}>
      <Button type={'reset'} size={size} theme={'fill_white_primary'} onClick={onClick}>
        Отменить
      </Button>
    </div>
  );
};
